import React, { useContext } from 'react';
import { LanguageContext } from '../../App';

const teamMembers = [
  {
    name: 'Mr. Manoj Kumar',
    role: {
      en: 'Founder & Chief Trustee',
      hi: 'संस्थापक और मुख्य ट्रस्टी'
    },
    phone: '+91 95409 36061',
    image: '/images/manojkumar_photo.jpeg',
    description: {
      en: "A visionary leader with over 15 years of experience in social service and community development. Mr. Manoj Kumar founded Radhe Krishna Sewa Samiti with a deep commitment to serving humanity. His leadership has been instrumental in organizing numerous charitable activities, including food distribution drives, educational support programs, and healthcare initiatives. Under his guidance, the organization has touched thousands of lives and continues to grow its impact in the community.",
      hi: "15 वर्षों से अधिक के सामाजिक सेवा और समुदाय विकास के अनुभव के साथ एक दूरदर्शी नेता। श्री मनोज कुमार ने मानवता की सेवा के प्रति गहरी प्रतिबद्धता के साथ राधे कृष्णा सेवा समिति की स्थापना की। उनके नेतृत्व ने कई धर्मार्थ गतिविधियों के आयोजन में महत्वपूर्ण भूमिका निभाई है, जिसमें भोजन वितरण अभियान, शैक्षिक सहायता कार्यक्रम और स्वास्थ्य सेवा पहल शामिल हैं। उनके मार्गदर्शन में, संगठन ने हजारों लोगों के जीवन को छुआ है और समुदाय में अपना प्रभाव बढ़ाता जा रहा है।"
    },
    achievements: {
      en: [
        'Led over 100+ community service initiatives',
        'Established educational support for 500+ underprivileged children',
        'Organized regular medical camps serving 2000+ people annually',
        'Created sustainable livelihood programs for rural communities'
      ],
      hi: [
        '100+ से अधिक सामुदायिक सेवा पहलों का नेतृत्व किया',
        '500+ वंचित बच्चों के लिए शैक्षिक सहायता स्थापित की',
        'प्रतिवर्ष 2000+ लोगों को सेवा प्रदान करने वाले नियमित चिकित्सा शिविरों का आयोजन किया',
        'ग्रामीण समुदायों के लिए स्थायी आजीविका कार्यक्रम बनाए'
      ]
    }
  },
  {
    name: 'Mr. Shobhit Singh',
    role: {
      en: 'Chairman',
      hi: 'अध्यक्ष'
    },
    phone: '+91 80105 01344',
    image: '/images/shobhitsingh_photo.jpeg',
    description: {
      en: 'The head of the organization who leads meetings and oversees all activities.',
      hi: 'संगठन के प्रमुख जो बैठकों का नेतृत्व करते हैं और सभी गतिविधियों की देखरेख करते हैं।'
    }
  },
  {
    name: 'Smt. Neha Singh',
    role: {
      en: 'Treasurer',
      hi: 'कोषाध्यक्ष'
    },
    phone: '+91 95409 36061',
    image: '/images/neha_photo.jpeg',
    description: {
      en: "Responsible for managing the organization's finances and maintaining accounts.",
      hi: "संगठन के वित्त का प्रबंधन और खातों का रखरखाव करने के लिए जिम्मेदार।"
    }
  },
  {
    name: 'Mr. Rajkumar Singh',
    role: {
      en: 'Auditor',
      hi: 'लेखा परीक्षक'
    },
    phone: '+91 80105 01344',
    image: '/images/rajkumarsingh_photo.jpeg',
    description: {
      en: 'Reviews and verifies the financial records to ensure accuracy and transparency.',
      hi: 'सटीकता और पारदर्शिता सुनिश्चित करने के लिए वित्तीय रिकॉर्ड की समीक्षा और सत्यापन करता है।'
    }
  }
];

const translations = {
  en: {
    title: 'About Us',
    subtitle: 'Meet Our Team',
    description: 'We are a dedicated team working together to serve our community with love and compassion.',
    contact: 'Contact',
    role: 'Role',
    mission: 'Our Mission',
    missionText: 'To serve humanity with love, compassion, and dedication, following the principles of Radhe Krishna Sewa Samiti.',
    vision: 'Our Vision',
    visionText: 'To create a harmonious society where everyone lives with dignity and respect, guided by spiritual values.',
    viewAll: 'View All Team Members',
    founderTitle: 'Our Founder',
    founderSubtitle: 'Leading with Vision and Compassion',
    achievements: 'Key Achievements',
    readMore: 'Read More About Our Founder',
    otherMembers: 'Other Team Members'
  },
  hi: {
    title: 'हमारे बारे में',
    subtitle: 'हमारी टीम',
    description: 'हम एक समर्पित टीम हैं जो प्रेम और करुणा के साथ अपने समुदाय की सेवा करने के लिए एक साथ काम कर रहे हैं।',
    contact: 'संपर्क',
    role: 'पद',
    mission: 'हमारा मिशन',
    missionText: 'राधे कृष्णा सेवा समिति के सिद्धांतों का पालन करते हुए प्रेम, करुणा और समर्पण के साथ मानवता की सेवा करना।',
    vision: 'हमारी दृष्टि',
    visionText: 'एक सामंजस्यपूर्ण समाज बनाना जहां हर कोई आध्यात्मिक मूल्यों के मार्गदर्शन में सम्मान और गरिमा के साथ जीवन जी सके।',
    viewAll: 'सभी टीम सदस्य देखें',
    founderTitle: 'हमारे संस्थापक',
    founderSubtitle: 'दृष्टि और करुणा के साथ नेतृत्व',
    achievements: 'प्रमुख उपलब्धियां',
    readMore: 'हमारे संस्थापक के बारे में और पढ़ें',
    otherMembers: 'अन्य टीम सदस्य'
  }
};

const AboutUsSection: React.FC = () => {
  const { language } = useContext(LanguageContext);
  const t = translations[language];
  const founder = teamMembers[0];
  const otherMembers = teamMembers.slice(1);

  return (
    <section className="py-16 bg-gray-50">
      <div className="container-custom">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4 font-hindi">{t.title}</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto font-hindi">{t.description}</p>
        </div>

        {/* Mission and Vision Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          <div className="bg-white rounded-lg shadow-lg p-8 transform hover:scale-105 transition-transform duration-300">
            <h3 className="text-2xl font-bold text-primary mb-4 font-hindi">{t.mission}</h3>
            <p className="text-gray-600 font-hindi">{t.missionText}</p>
          </div>
          <div className="bg-white rounded-lg shadow-lg p-8 transform hover:scale-105 transition-transform duration-300">
            <h3 className="text-2xl font-bold text-primary mb-4 font-hindi">{t.vision}</h3>
            <p className="text-gray-600 font-hindi">{t.visionText}</p>
          </div>
        </div>

        {/* Founder Section */}
        <div className="mb-16">
          <h2 className="text-3xl font-bold text-center mb-8 font-hindi">{t.founderTitle}</h2>
          <div className="bg-white rounded-xl shadow-xl overflow-hidden max-w-4xl mx-auto">
            <div className="flex flex-col items-center p-8">
              {/* Founder Image - Made circular */}
              <div className="relative w-64 h-64 md:w-80 md:h-80 mb-8">
                <div className="absolute inset-0 rounded-full overflow-hidden border-4 border-primary/20">
                  <img
                    src={founder.image}
                    alt={founder.name}
                    className="w-full h-full object-cover object-center"
                    style={{
                      filter: "brightness(1.05) contrast(1.05)",
                      objectPosition: "center 20%"
                    }}
                  />
                </div>
              </div>

              {/* Founder Info */}
              <div className="text-center">
                <h3 className="text-3xl font-bold text-gray-900 mb-2">{founder.name}</h3>
                <p className="text-xl text-primary font-semibold mb-4 font-hindi">{founder.role[language]}</p>
                
                <div className="max-w-2xl mx-auto">
                  <p className="text-gray-600 leading-relaxed mb-6 font-hindi">{founder.description[language]}</p>
                </div>

                {founder.achievements && (
                  <div className="mb-6">
                    <h4 className="text-xl font-semibold text-gray-900 mb-3 font-hindi">{t.achievements}</h4>
                    <ul className="space-y-2">
                      {founder.achievements[language]?.map((achievement, index) => (
                        <li key={index} className="flex items-center justify-center">
                          <svg className="w-5 h-5 text-primary mt-1 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                          </svg>
                          <span className="text-gray-600 font-hindi">{achievement}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                <div className="flex items-center justify-center text-gray-700 mb-6">
                  <div className="bg-primary/10 p-3 rounded-full">
                    <svg className="w-6 h-6 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                  </div>
                  <span className="text-lg ml-4">{founder.phone}</span>
                </div>

                <button className="inline-flex items-center px-6 py-3 bg-primary text-white rounded-lg hover:bg-primary-dark transition-colors duration-300">
                  <span className="font-hindi">{t.contact}</span>
                  <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Other Team Members Section */}
        <h3 className="text-3xl font-bold text-center mb-8 font-hindi">{t.otherMembers}</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {otherMembers.map((member, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-lg overflow-hidden transform hover:scale-105 transition-transform duration-300"
            >
              <div className="relative">
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-64 object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
              </div>
              <div className="p-6">
                <h4 className="text-xl font-semibold text-gray-900 mb-2">{member.name}</h4>
                <p className="text-primary font-medium mb-2 font-hindi">{member.role[language]}</p>
                <p className="text-gray-600 mb-4 font-hindi">{member.description[language]}</p>
                <div className="flex items-center text-gray-700">
                  <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                  <span>{member.phone}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <a
            href="/about"
            className="inline-block px-8 py-3 bg-primary text-white rounded-full hover:bg-opacity-90 transition-colors font-hindi"
          >
            {t.viewAll}
          </a>
        </div>
      </div>
    </section>
  );
};

export default AboutUsSection; 